import { useSession } from '@sunucupark/client-react';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { connectRealtime } from './realtime';
import { useWebClient } from './use-web-client';

/**
 * Keeps the live channel open while someone is signed in. It renders nothing:
 * the events only invalidate query caches (ADR 0008).
 */
export function RealtimeBridge() {
  const client = useWebClient();
  const queryClient = useQueryClient();
  const session = useSession();
  const accountId = session?.accountId;

  useEffect(() => {
    if (!accountId) return;
    return connectRealtime(client, queryClient);
  }, [accountId, client, queryClient]);

  return null;
}
